<script lang="ts">
    import ZentitySelect from '../_common/z/zentity-select.svelte'
    import Fa from 'svelte-fa'
    import { faEdit, faTrashAlt, faCheck } from '@fortawesome/free-solid-svg-icons'
    import { createEventDispatcher, onMount } from 'svelte'
    import { AppointmentItem } from '../../modules/schedulerApi/appointments/appointment-item'
    import ServiceSelect_2 from '../pos/service-select-2.svelte'
    import { User } from '../../modules/usersApi/users/user'
    import { AppointmentStatus } from '../../modules/schedulerApi/appointments/appointments.enum'
    import ZContainer from '../_common/z/z-container.svelte'
    import Zbutton from '../_common/z/zbutton.svelte'
    import ZContainerCol from '../_common/z/z-container-col.svelte'
    import { slide } from 'svelte/transition'
    const dispatch = createEventDispatcher()

    let className: string = ''
    export { className as class }
    export let appointmentItem: AppointmentItem = undefined
    export let userId: string = null
    export let personId: string = null
    export let allowed: string[] = []
    export let scheduleId: string
    export let status: AppointmentStatus

    let blink = false

    let statusWithNoOnus = [
        AppointmentStatus.agendamento_remarcado,
        AppointmentStatus.agendamento_cancelado_empresa,
        AppointmentStatus.agendamento_cancelado_usuario,
    ]

    let step = 1
    let isNew = false
    async function editEntity() {
        step = 2
    }

    async function newEntity() {
        isNew = true
        step = 2
        appointmentItem = new AppointmentItem()
        if (userId) {
            appointmentItem.user = new User()
            appointmentItem.user.userId = userId
        }
    }

    async function cancelEntity() {
        appointmentItem = undefined
        step = 1
        dispatch('cancel')
    }

    async function confirmEntity() {
        if (!validateFields()) return
        dispatch('added', appointmentItem)
        if (isNew) appointmentItem = undefined
        step = 1
        isNew = false
        blink = true
        setTimeout(() => {
            blink = false
        }, 2000)
    }

    function validateFields() {
        if (!appointmentItem.user) {
            evaluateError('Informe o atendente')
            return false
        }
        if (!appointmentItem.service) {
            evaluateError('Informe o serviço')
            return false
        }
        return true
    }

    function evaluateError(error) {
        window.error(error)
    }

    onMount(() => {
        if (!appointmentItem) newEntity()
    })
</script>

{#if appointmentItem !== undefined}
    {#if step === 1}
        <ZContainer class="h-mobile liner">
            <ZContainerCol size={3} flex={true} verticalAlign="center">
                {appointmentItem.user?.userName || appointmentItem.user?.email}
            </ZContainerCol>
            <ZContainerCol size={7} flex={true} verticalAlign="center">
                {#if appointmentItem.parentServicesOnInvoicesId}
                    {#if statusWithNoOnus.includes(status)}
                        <div class="badge badge_secondary">não consumido do saldo</div>
                    {:else}
                        <div class="badge badge_secondary">consumido do saldo</div>
                    {/if}
                {/if}
                {appointmentItem.service?.name || '-'}
            </ZContainerCol>
            <ZContainerCol size={2} flex={true} horizontalAlign="end">
                <Zbutton class="my-1" label="Editar" on:click={editEntity} icon={faEdit}></Zbutton>
            </ZContainerCol>
        </ZContainer>
        <div class="row liner h-full item-static {className}" class:blink>
            <div class="col-10 nowrap ps-0">
                {appointmentItem.user?.userName || appointmentItem.user?.email}<br />
                {appointmentItem.service?.name || '-'}
            </div>
            <div class="col-2 d-flex justify-content-end pe-0">
                <Zbutton color="primary" on:click={editEntity} icon={faEdit}></Zbutton>
            </div>
        </div>
    {/if}
    {#if step === 2}
        <div class="py-1">
            <ZContainer>
                <ZContainerCol size={3} sizeM={12}>
                    <ZentitySelect fonte="usuario" label="Atendente" somenteIds={allowed} bind:value={appointmentItem.user}></ZentitySelect>
                </ZContainerCol>
                <ZContainerCol size={7} sizeM={12}>
                    <ServiceSelect_2
                        v2={true}
                        onlyWithBalance={window.configs.schedulueOnlyWithBalanceOrNoValue}
                        duration={true}
                        price={false}
                        label="Serviço"
                        small={true}
                        bind:service={appointmentItem.service}
                        bind:balance_parentServicesOnInvoicesId={appointmentItem.parentServicesOnInvoicesId}
                        bind:balanceResultId={appointmentItem.groupId}
                        bind:invoiceId={appointmentItem.invoiceId}
                        balance={true}
                        {scheduleId}
                        {personId}
                    />
                </ZContainerCol>
                <ZContainerCol flex={true} size={2} sizeM={12}>
                    <div class="spacer"></div>
                    <Zbutton color="red" class="me-2" on:click={cancelEntity} icon={faTrashAlt}></Zbutton>
                    <Zbutton color="primary" label="Confirmar" on:click={confirmEntity} icon={faCheck}></Zbutton>
                </ZContainerCol>
            </ZContainer>
        </div>
    {/if}
{/if}

<style>
    @media (max-width: 900px) {
        .item-static button {
            margin-top: 6px !important;
            margin-bottom: 8px !important;
        }
        .edit-form {
            z-index: 1;
            position: relative;
            background: #00000050;
            border-radius: 4px;
        }
        .edit-outer {
            position: absolute;
            top: 0px;
            left: 0px;
            height: 100vh;
            width: 100vw;
            background: #99999999;
            z-index: 0;
        }
    }
</style>
